import TicketApproController from './ticket.appro.controller';
import Template from './ticket.appro.html';

export default {
	template: Template,
	controller: TicketApproController
};
